import { Type } from 'main.core';

export class TextNodeType
{
	static TEXT: string = 'text';
	static HTML: string = 'html';

	static isValid(type: unknown): type is TextNodeType
	{
		return Type.isString(type) && (type === this.HTML || type === this.TEXT);
	}
}
